import React from "react";
import classes from "../LatestManual/input.module.css";
import pdfImg from "../../../assets/images/pdf img.svg";

const TodaysEvent = () => {
   return (
      <div className={classes.manuals_container}>
         <div className={classes.manual}>
            <div className={classes.imgContainer}>
               <img src={pdfImg} alt="pdf" />
            </div>
            <div className={classes.info}>
               <p>
                  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                  diam nonumy eirmod tempor invidunt ut labore et dolore magna
                  aliquyam erat, sed diam voluptua. At vero eos et
               </p>
            </div>
         </div>
         <div className={classes.manual}>
            <div className={classes.imgContainer}>
               <img src={pdfImg} alt="pdf" />
            </div>
            <div className={classes.info}>
               <p>
                  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                  diam nonumy eirmod tempor invidunt ut labore et dolore magna
                  aliquyam erat, sed diam voluptua. At vero eos et
               </p>
            </div>
         </div>
         <div className={classes.manual}>
            <div className={classes.imgContainer}>
               <img src={pdfImg} alt="pdf" />
            </div>
            <div className={classes.info}>
               <p>
                  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                  diam nonumy eirmod tempor invidunt ut labore et dolore magna
                  aliquyam erat, sed diam voluptua. At vero eos et
               </p>
            </div>
         </div>
         <div className={classes.manual}>
            <div className={classes.imgContainer}>
               <img src={pdfImg} alt="pdf" />
            </div>
            <div className={classes.info}>
               <p>
                  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                  diam nonumy eirmod tempor invidunt ut labore et dolore magna
                  aliquyam erat, sed diam voluptua. At vero eos et
               </p>
            </div>
         </div>
      </div>
   );
};

export default TodaysEvent;
